import React, { useContext, useEffect, useState } from "react";
import { classesURL, reportsClassesURL } from "../../Hooks/URL";
import useFetch from "../../Hooks/useFetch";
import { useNavigate, useParams } from "react-router-dom";
import useUpdate from "../../Hooks/useUpdate";
import ClassReportDetails from "../../Templates/Reports/ClassReportDetails/ClassReportDetails";
import { userContext } from "../../Contexts/userContext";

function ClassReportDetailsPage() {
  let { id, report_id } = useParams();
  const navigate = useNavigate();
  const { contextData, setContextData } = useContext(userContext);

  const url = `${classesURL}/${id}`;

  const [reportsVisible, setReportsVisible] = useState(false);

  const [report, setReport] = useState({});
  const {
    data: reportData,
    loading: reportLoading,
    error: reportError,
  } = useFetch(`${classesURL}/${id}/class-feedbacks/${report_id}`);

  const [students, setStudents] = useState([]);
  // const {
  //   data: studentsData,
  //   loading: studentsLoading,
  //   error: studentsError,
  //   // } = useFetch(`${classesURL}/${id}/students`);
  // } = useFetch(`${classesURL}/${id}/class-feedbacks/${report_id}/students`);

  const [Class, setClass] = useState({});
  const { data, loading, error } = useFetch(url);

  const [goEdit, setGoEdit] = useState(false);
  const { loading: editLoading } = useUpdate({
    url: `${classesURL}/${id}/class-feedbacks/${report_id}/readyStatus`,
    goEdit,
    setGoEdit,
    newObject: {
      ready: !reportsVisible,
    },
    refreshAfter: true,
  });

  useEffect(() => {
    if (!loading && !error && data) {
      setClass(data.data);
    }
  }, [data, loading, error]);

  useEffect(() => {
    if (!reportLoading && !reportError && reportData) {
      setReport(reportData.data);
      setStudents(reportData.data?.students);
      setReportsVisible(reportData.data?.readyStatus);
    }
  }, [reportData, reportLoading, reportError]);

  useEffect(() => {
    setContextData({ ...contextData, page: "classes", data: Class?.className });
  }, [Class]);

  return (
    <ClassReportDetails
      Class={Class}
      classId={id}
      students={students}
      // studentsLoading={studentsLoading}
      loading={loading}
      reportsVisible={reportsVisible}
      setReportsVisible={setReportsVisible}
      setGoEdit={setGoEdit}
      setStudents={setStudents}
      report_id={report_id}
      report={report}
    />
  );
}

export default ClassReportDetailsPage;
